import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtaButtonComponent } from './cta-button.component';
import { CapturumButtonModule } from '@capturum/ui/button';

@NgModule({
  declarations: [
    CtaButtonComponent,
  ],
  imports: [
    CommonModule,
    CapturumButtonModule,
  ],
  exports: [
    CtaButtonComponent,
  ]
})
export class CapturumCtaButtonModule { }
